<template>
  <k-video-area ref="area" :items="items" :groups="groups" storage-key="monitor2" :max-entries="1000" @group-title="rename_group" @group-color="set_group_color" @group-remove="remove_group" @group-removed="remove_group_videos">
    <template #default="{ item }">
      <instance-item v-if="item.type == 'instance'" :data="item"></instance-item>
      <item v-else :data="item" :timestamp="ts" :auto-start="!!autostart[item.id]"></item>
    </template>
  </k-video-area>
</template>

<script>
import ChannelModel from '@/models/channel.js';
import { monitor2Items, monitor2Groups, parseMonitor2Key, toggleMonitor2Items, renameMonitor2Group, setMonitor2GroupColor, removeMonitor2Group } from '@/models/monitor.js';
import eventsMixin from './events.js';
import Item from './Item'
import InstanceItem from './InstanceItem'

export default {
  mixins: [eventsMixin],
  components: {
    Item,
    InstanceItem
  },
  computed: {
    selected () {
      return monitor2Items(this.$store.state.account);
    },
    groups () {
      return monitor2Groups(this.$store.state.account);
    },
    events_by_uuid () {
      return _.keyBy(this.events, "uuid");
    },
    items () {
      var res = [];
      this.selected.forEach((key) => {
        var parsed = parseMonitor2Key(key);
        if (parsed.type == "channel") {
          var channel = ChannelModel.channel_by_uuid(parsed.uuid);
          if (channel) res.push({id: key, type: "channel", channel: channel, alternative: parsed.alternative});
        } else if (parsed.type == "event") {
          var event = this.events_by_uuid[parsed.uuid];
          if (event) res.push({id: key, type: "event", view: parsed.view, event: event});
        } else if (parsed.type == "instance") {
          var instance = this.$store.state.instances[parsed.id];
          // Instance stats aren't video, so their tiles can have any size
          if (instance) res.push({id: key, type: "instance", instance: instance, free_size: true});
        }
      });
      return res;
    }
  },
  watch: {
    // Videos added from the sidebar go to the first free spot, not where they were before.
    // Saved layout data of removed videos and groups is dropped.
    selected (keys, old) {
      if (!old || !this.$refs.area) return;
      var added = keys.filter(k => !old.includes(k));
      // Videos added during this page load start playing by themselves
      added.forEach(k => this.$set(this.autostart, k, true));
      old.forEach(k => { if (!keys.includes(k)) this.$delete(this.autostart, k); });
      if (old.some(k => !keys.includes(k))) this.$refs.area.prune_layout(keys);
      if (added.length) this.$refs.area.place_as_new(added);
    }
  },
  mounted () {
    // Cleans up data left by videos and groups removed elsewhere (e.g. on another device)
    this.$refs.area.prune_layout(this.selected);
    this.$root.$on("monitor2:play-all", this.play_all);
  },
  beforeDestroy () {
    this.$root.$off("monitor2:play-all", this.play_all);
  },
  data () {
    return {
      autostart: {}
    }
  },
  methods: {
    // Starts every player that isn't playing yet (sent by the sidebar's play button)
    play_all () {
      var players = [];
      var collect = (vm) => {
        vm.$children.forEach((child) => {
          if (child.$options.name === "KVideoPlayer") players.push(child);
          else collect(child);
        });
      };
      collect(this);
      players.forEach((player) => player.start());
    },
    rename_group ({id, title}) {
      var acc = _.cloneDeep(this.$store.state.account);
      this.$store.dispatch("update_profile", renameMonitor2Group(acc, id, title));
    },
    set_group_color ({id, color}) {
      var acc = _.cloneDeep(this.$store.state.account);
      this.$store.dispatch("update_profile", setMonitor2GroupColor(acc, id, color));
    },
    // Removes the group and the videos inside it
    remove_group (id, keys) {
      var acc = _.cloneDeep(this.$store.state.account);
      toggleMonitor2Items(acc, keys || [], false);
      this.$store.dispatch("update_profile", removeMonitor2Group(acc, id));
    },
    // A group was removed elsewhere (e.g. the event group button in the sidebar): its videos go with it
    remove_group_videos (id, keys) {
      var acc = _.cloneDeep(this.$store.state.account);
      this.$store.dispatch("update_profile", toggleMonitor2Items(acc, keys, false));
    },
    // Removes events (and their event groups) that are no longer in today's event list
    on_events_loaded () {
      var stale = this.selected.filter((key) => {
        var parsed = parseMonitor2Key(key);
        return parsed.type == "event" && !this.events_by_uuid[parsed.uuid];
      });
      var stale_groups = this.groups.filter((g) => g.event && !this.events_by_uuid[g.event]);
      if (!stale.length && !stale_groups.length) return;
      var acc = _.cloneDeep(this.$store.state.account);
      toggleMonitor2Items(acc, stale, false);
      stale_groups.forEach((g) => removeMonitor2Group(acc, g.id));
      this.$store.dispatch("update_profile", acc);
    }
  }
}
</script>
